import { useRef, useState } from "react";
import { RegexMatcher } from "../../../models/matchers/RegexMatcher";
import { RegexValidatorResponse } from "../../../models/regex/RegexValidator";
import { InputGroup } from "../../inputGroup/InputGroup";
import { MatcherLabel } from "../../inputGroup/MatcherLabel";
import { RegexError } from "../../regex/RegexError";
import { RegexInput } from "../../regex/RegexInput";
import { MatcherEditorChildProps } from "../MatcherEditor";

export { RegexMatcherEditor };

type Props = {
  update: (matcher: RegexMatcher) => void;
} & MatcherEditorChildProps<RegexMatcher>;

const RegexMatcherEditor = (props: Props) => {
  const groupRef = useRef<HTMLSpanElement | null>(null);
  const [error, setError] = useState<RegexValidatorResponse | undefined>();

  return (
    <div className={"matcherEditor regexMatcherEditor"}>
      <InputGroup ref={groupRef} button={props.button != undefined}>
        <MatcherLabel label={"Regex"} {...props} />

        <RegexInput
          initialValue={props.matcher.regex}
          parentRef={groupRef}
          updated={(result: RegexValidatorResponse) => {
            setError(result);
            if (result.valid) {
              props.matcher.regex = result.regex;
              props.update(props.matcher);
            }
          }}
        />
        {props.button && props.button}
      </InputGroup>

      <RegexError error={error} />
    </div>
  );
};
